import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Exclude } from 'class-transformer';
export class AddressRawDto {
    constructor() {
        this.countryCode = 'US';
        this.country = 'United States';
    }
    get addressText() {
        return [this.address01, this.city, this.state, this.postalCode]
            .filter((t) => Utils.notNullOrEmpty(t))
            .join(', ');
    }
    toString() {
        return [
            this.address01 || '',
            this.address02 || '',
            this.address03 || '',
            this.city,
            this.state,
            this.postalCode
        ]
            .filter((token) => Utils.notNullOrEmpty(token))
            .join(', ');
    }
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], AddressRawDto.prototype, "stateCode", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], AddressRawDto.prototype, "country", void 0);
